module.exports = __webpack_public_path__ + "static/media/c_03.a64b14cd.png";